import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Stack, Tooltip, Typography } from '@mui/material'

interface IProps {
  tooltip: string
  color?: 'warning.dark' | 'error.main'
}

export const NotGeneratedCell = (props: IProps) => {
  const { tooltip, color = 'warning.dark' } = props

  return (
    <Tooltip title={tooltip}>
      <Stack direction='row' alignItems='center' spacing={0.5} sx={{ color }}>
        <WarningAmberIcon fontSize='small' />
        <Typography variant='body2' fontWeight={600}>
          None
        </Typography>
      </Stack>
    </Tooltip>
  )
}
